/* THE BANKER'S LAMP ON THE DESK: mesh, material, base, the shadow that
   base throws on the oak, the source - C0 gathered them out of place.js
   and objects.js, which keep the pose and the two draws. THE RULE THE
   BLOCKS CITE: the shadow entry is `opts.own`, "I paint my own", because
   the list makes squares and this base is a turned disc. `O.lamp.source`
   is entry ZERO of `RoomPlace.lights`, R75's slot. `?lampx=` `?lampy=`
   move the base, `?edgelamp=1` also draws the solid at the desk pose,
   `?lamp=0` takes lamp, light, pool and shadow away.
   REPORT-room-C0.md, -R27.md, -DL1.md, -LT1.md, -BL1.md. */
(function () {
'use strict';
var O = window.RoomObjects;
if (!O || !O.piece) return;

var Q = new URLSearchParams(location.search);
var EDGE = true;                    /* R17 (c): the chosen edge pose */

/* R27 (2): the tell is the lamp, not a picture of its base. Tommy on
   R17's disc: "the lamp base doesn't look like a lamp base? surely you'd be seeing the lamp from above at an angle?"
   So the desk pass paints the SHADOW only, place.js's mesh over it. The
   base sits 30 mm west, 114 mm north of the sheet's NW corner, where the
   hood clears the north fold's closest station by 120.0 mm. */
var LAMP_MM = [+(Q.get('lampx') || -30), +(Q.get('lampy') || -114)];
var LAMP_R_MM = 82;
var EDGE_LAMP = !(Q.get('edgelamp') === '0' || Q.get('edgelamp') === 'off');   /* LS1: on (engine.js) */
/* LS1: the shadow is the lamp's, so it is down when the lamp is: place.js
   builds the solid after the map is up, and until then there is nothing
   standing there to cast it. */
function lampUp() { return !NO_LAMP && !!(window.RoomPlace && RoomPlace.lampReady); }
/* R27 (2): where the base stands, css px - one function, so the desk's
   shadow and place.js's solid cannot drift */
O.lampBase = function (S) {
  var L = S.layout, mm = S.fld.sheet.w * L.k / 840;
  return { x: L.ox + LAMP_MM[0] * mm, y: L.oy + LAMP_MM[1] * mm, r: LAMP_R_MM * mm, mm: mm };
};

/* ====================================================================
   BL1: THE BANKER'S LAMP IS A BANKER'S LAMP
   Tommy, 2026-09-18, a photograph of a real one on the desk beside him:
   "Are we also happy with the model of our banker's lamp?" and
   "it should be more like this, right?"

   It should. What stood here was a PUCK, a STICK and a BARREL: three
   stacked discs 18 mm tall on the 164 mm footprint, a straight 9-10 mm
   tube from 30 to 318, and a 188 x 80 half-cylinder of green glass with
   FLAT triangular cheeks whose inside was painted a flat LIGHT GREEN.
   Measured off the BEFORE crop at the room pose (BL1-PAIR-lamp-day-3x):
   base 263 x 143 device px of one sixteen-sided ellipse; hood 426 x 187,
   of which the light-green inner face was the single largest area on the
   lamp and carried no gradient at all.

   What stands here now is an Emeralite-pattern lamp, every number in mm:
     BASE   a turned BELL on one revolved profile - a 164 foot with two
            stepped rings (6 and 5), a concave bell to a 55 waist at 60,
            a flat ledge, a baluster KNOP bulging to 65 and drawn to a
            35 collar, and a small collar at 100 where the stem enters.
     NECK   a 10 tube that leaves the knop VERTICALLY and sweeps forward
            in one curve to the head - a swan neck, in its own frame.
     PIVOT  a yoke to the shade's two ends, a boss at each, a knurled nut
            at one: what says the shade TILTS.
     SHADE  cased glass - emerald outside, CREAM inside - a flattened
            arch with a flared front lip, CURVED cheeks that close the
            hood, and a brass welt round the whole lower edge.
     CHAIN  a bead chain and its brass ball: the one thing on this lamp a
            hand has touched.
   ==================================================================== */

/* The lamp's own millimetres. Every one of them is in this block so the
   report and the mesh cannot drift apart. */
var MM_ = {
  /* the base, revolved: the foot's own height is what the oak's contact
     term is struck from (see FOOT_H below), the whole base is 100 */
  footR: LAMP_R_MM,       // 82 - 164 across, the footprint the oak expects
  waistR: 27.5,           // 55 across at 60 up, the card's waist
  waistZ: 60,
  knopR: 32.5,            // 65 across, the baluster's bulge
  collarR: 17.5,          // 35 across, the knop's top collar
  baseH: 100,             // the whole base, inside the card's 95-110
  /* the neck */
  stemR: 5,               // 10 across
  headY: 34,              // place.js's own offset to the head, NOT moved (OPEN 1)
  headZ: 330,
  /* the hood: 188 x 80 x 42, the envelope place.js publishes as
     MEASURED.deskLamp.shade and scripts/test-room-measurements.js
     measures the whole fold sweep against (OPEN 2) */
  hoodHalfL: 94, hoodHalfD: 40, hoodRise: 42, hoodLipZ: -60,
  hoodCap: 22,            // the curved cheek's run at each end
  rimW: 2.0, rimDrop: 4.0,
  chainL: 150, chainR: 1.6, ballR: 5.0
};

/* LT1's contract, unchanged by this card: `uGlow` is the lamp's SWITCH,
   not the hour, and it is 1 at 14:00 and at 23:00 alike. What makes the
   day read softer is `uSrc` (`dim = 1 - night*0.86` in both draws) and
   the light list's own exposure `mix(0.20,1,night)` in place.js - not a
   turned-down bulb. HANDOVER item 2, Tommy: "Desk banker's lamp ON in daylight AND night ... Change both illumination and VISIBLE EMISSION, not just the source metadata." */
var LAMP_VS = `#version 300 es
precision highp float;
layout(location = 0) in vec3 a; layout(location = 1) in vec3 nrm; layout(location = 2) in float part;
uniform mat4 uVP; uniform mat4 uM; uniform mat4 uMNeck; uniform mat4 uMHead;
out vec3 vN; out vec3 vW; out float vP; out vec3 vL;
void main(){
  /* BL1: THREE FRAMES, not two. The base has no yaw; the head has yaw
     AND the 38 degree tilt; a curved neck can live in neither, because
     it leans toward the AIM (a runtime yaw) while standing upright on
     the base. uMNeck is the base's origin, yawed, untilted - the one
     uniform this card adds, and the one edit it makes to place.js's two
     draws. The chain hangs in it too: a chain hangs by gravity, so it
     belongs in the untilted frame however the head is turned. */
  mat4 M = part < 0.5 ? uM : (part < 1.5 ? uMNeck : uMHead);
  vec4 w = M*vec4(a, 1.0);
  vW = w.xyz; vP = part;
  vN = normalize(mat3(M)*nrm);
  vL = a;                 /* BL1: the LOCAL millimetres - the cased glass
                             below measures the bulb in them, so no world
                             scale enters the transmission term */
  gl_Position = uVP*w;
}`;

var LAMP_FS = `#version 300 es
precision highp float;
in vec3 vN; in vec3 vW; in float vP; in vec3 vL; out vec4 o;
uniform vec3 uSrc, uWinC, uEye; uniform float uRoom, uGlow;
void main(){
  vec3 n = normalize(vN);
  vec3 l = normalize(uWinC - vW);
  vec3 v = normalize(uEye - vW);
  float d = max(0.0, dot(n, l));
  float side = dot(n, v);            /* > 0 the outside of the glass, < 0 the inside */
  bool glass = vP > 1.5 && vP < 2.5;
  vec3 base = glass ? vec3(0.055,0.245,0.125) :
              (vP > 2.5 ? vec3(0.55,0.405,0.145) : vec3(0.40,0.285,0.105));
  vec3 col = base*(0.22 + 0.85*d)*uSrc;
  float rim=pow(1.0-abs(side),3.0);
  if(glass){
    /* ==== BL1: THE SHADE IS CASED GLASS ==========================
       Tommy's photograph: emerald outside, WHITE inside, lit warm by the
       bulb. What was here painted the inside a flat LIGHT GREEN
       (vec3(.72,.90,.57)) with no gradient, which is why the hood read
       as a folded strip of card.

       THE BULB is at head-local (0,0,-34) mm - inside the hood, where a
       socket under the shade puts it - and vL is head-local mm for
       every glass vertex, so near is a real inverse-square falloff in
       millimetres with no world scale in it. inc is the incidence: a
       piece of glass seen edge-on shows a long path through it and goes
       dark, which is the photograph's darkest edge. Neither is a
       texture; both are the surface's own geometry, as the card asks. */
    vec3 bl = vL - vec3(0.0, 0.0, -34.0);
    float bd = length(bl)/34.0;
    float near = 1.0/(1.0 + bd*bd);   /* 0.82 at the crown, 0.30 at the front lip, 0.11 at the cheeks */
    float inc = abs(side);
    if(side < 0.0){
      /* THE INSIDE IS CREAM. The room gets very little of itself in
         here, so the ambient is small and everything else is the bulb. */
      vec3 cream = vec3(0.93,0.88,0.72);
      col = cream*uSrc*0.20
          + cream*vec3(1.0,0.88,0.70)*uGlow*(0.16 + 0.80*near);
    } else {
      /* THE OUTSIDE TRANSMITS. Dark emerald, plus a bounded term toward
         a bright green where the bulb is behind the glass and the glass
         is not seen edge-on. R73's rule: bounded, never a white flash -
         the term carries the GREEN, is clamped at 1, and its own peak
         (crown, face-on) is 0.82. */
      float tr = clamp(uGlow*near*(0.30 + 0.70*inc), 0.0, 1.0);
      col += vec3(0.025,0.20,0.075)*(.20+.42*rim)
           + vec3(0.30,0.72,0.28)*tr*0.85;
    }
  } else {
    col+=vec3(.34,.22,.055)*(.05+.20*rim);
    /* BL1: THE FITTINGS ARE INSIDE THE SHADE'S LIGHT. The welt round the
       hood's mouth, the yoke and the two bosses (part 3, the head's own
       frame) stand in the bulb's own light and took only the flat 0.025
       wash below, so at 23:00 - where uSrc is a seventh of its daylight -
       a brass rim touching a lit shade read as a black line. The same
       bulb, the same inverse square, the same head-local millimetres as
       the glass: 0.14 of warm at the front lip, 0.04 at the nut. The
       base and the neck (parts 0 and 1) keep the flat wash - they are
       under the shade, in its own shadow, which is where they look. */
    if (vP > 2.5) {
      vec3 bb = vL - vec3(0.0, 0.0, -34.0);
      float bq = length(bb)/34.0;
      col += vec3(1.0,0.80,0.52)*uGlow*0.35/(1.0 + bq*bq);
    }
  }
  col += vec3(1.0,0.72,0.38)*uGlow*0.05*(glass ? 1.0 : 0.5);
  o = vec4(col, uRoom);
}`;

/* C0: `mesh` is handed in - place.js's one buffer builder. */
function lampMesh(gl, mesh) {
  var pos = [], nor = [], prt = [], idx = [], n = 0;

  /* ==== BL1: THE LATHE ============================================
     "every dimension in mm, normals from the lathe (a revolved thing's
     normals are its own - no faked shading)". The pattern is DR2's door
     knob, copied here rather than called across files: each course of a
     profile has its own outward normal in (z,r); where two courses meet
     at less than about 70 degrees they are averaged into one ring (a
     turned edge rounds), and past that they are CREASED into two rings
     at the same place (a step is a step). What went before pushed
     `(nx/m, ny/m, 0.25)` for every tube - the same made-up upward lean
     on a bell, a stem and a collar alike.

     mm -> world is one uniform scale in place.js's `model`, so a normal
     struck in the profile's own millimetres IS the world normal. ==== */
  function lathe(profile, part, sides) {
    var N = profile.length, S = sides || 28, i, j, seg = [];
    for (i = 0; i < N - 1; i++) {
      var dz = profile[i+1][0] - profile[i][0], dr = profile[i+1][1] - profile[i][1];
      var L = Math.hypot(dz, dr) || 1;
      seg.push([-dr/L, dz/L]);            // (axial, radial), pointing out of the solid
    }
    var rowIn = [], rowOut = [];
    function ring(z, r, nn) {
      var k = n;
      for (j = 0; j < S; j++) {
        var t = j*2*Math.PI/S, c = Math.cos(t), s = Math.sin(t);
        pos.push(r*c, r*s, z); nor.push(nn[1]*c, nn[1]*s, nn[0]); prt.push(part); n++;
      }
      return k;
    }
    for (i = 0; i < N; i++) {
      var a1 = i > 0 ? seg[i-1] : null, b1 = i < N-1 ? seg[i] : null;
      if (a1 && b1 && a1[0]*b1[0] + a1[1]*b1[1] > 0.35) {
        var sx = a1[0]+b1[0], sy = a1[1]+b1[1], Ls = Math.hypot(sx,sy) || 1;
        rowIn[i] = rowOut[i] = ring(profile[i][0], profile[i][1], [sx/Ls, sy/Ls]);
      } else {
        rowIn[i]  = ring(profile[i][0], profile[i][1], a1 || b1);
        rowOut[i] = (a1 && b1) ? ring(profile[i][0], profile[i][1], b1) : rowIn[i];
      }
    }
    for (i = 0; i < N - 1; i++) for (j = 0; j < S; j++) {
      var j2 = (j+1)%S, A = rowOut[i]+j, B = rowOut[i]+j2, C = rowIn[i+1]+j, D = rowIn[i+1]+j2;
      idx.push(A, C, B, B, C, D);
    }
  }

  /* A TUBE ALONG A CURVE, for the swan neck and the chain. The path is
     in the local (y,z) plane, so its frame needs no parallel transport:
     the ring is spanned by x and by the path's own left normal. The
     normals are the tube's, struck from that frame. */
  function sweep(path, r0, r1, part, sides, closeTop) {
    var S = sides || 12, i, j, rows = [];
    for (i = 0; i < path.length; i++) {
      var p = path[i];
      var q = path[Math.min(i+1, path.length-1)], b = path[Math.max(i-1, 0)];
      var ty = q[0]-b[0], tz = q[1]-b[1], L = Math.hypot(ty, tz) || 1;
      ty /= L; tz /= L;
      var u = i/(path.length-1), r = r0 + (r1-r0)*u;
      rows.push(n);
      for (j = 0; j < S; j++) {
        var t = j*2*Math.PI/S, c = Math.cos(t), s = Math.sin(t);
        /* the ring's two axes: world x, and the path's left normal (0,-tz,ty) */
        var nx = c, ny = s*(-tz), nz = s*ty;
        pos.push(r*nx, p[0] + r*ny, p[1] + r*nz);
        nor.push(nx, ny, nz); prt.push(part); n++;
      }
    }
    for (i = 0; i < rows.length-1; i++) for (j = 0; j < S; j++) {
      var j2 = (j+1)%S;
      idx.push(rows[i]+j, rows[i+1]+j, rows[i]+j2,
               rows[i]+j2, rows[i+1]+j, rows[i+1]+j2);
    }
    if (closeTop) {                       // a flat cap, for the chain's ball only
      var e = path[path.length-1], k = n, ty2 = 0;
      pos.push(0, e[0], e[1]); nor.push(0, 0, 1); prt.push(part); n++;
      for (j = 0; j < S; j++) idx.push(k, rows[rows.length-1]+j, rows[rows.length-1]+(j+1)%S);
      ty2 = ty2;
    }
  }

  /* ==== 1. THE BASE: ONE PROFILE, REVOLVED =========================
     The card: "a foot ~165 mm across with two stepped rings at the bottom
     (~6 mm each), a concave bell rising to a waist ~55 mm across at
     ~60 mm up, a flat ledge, and above it a turned baluster KNOP (a
     bulge ~65 mm across, a collar ~35 mm) with a small collar at the top
     where the stem enters, the whole base ~95-110 mm tall."
     The FOOTPRINT is unchanged - 82 mm, the radius the oak's contact
     shadow and `O.lampBase` expect. The whole base is 100 mm tall. ==== */
  var BP = [[0, 82], [6, 82], [6, 78],           // ring one, and its step
            [11, 78], [11, 74],                  // ring two, and its step
            [14, 72]];                           // the bell springs
  /* the concave bell, seven courses: r = 27.5 + 44.5*(1-u)^1.42 - steep
     off the foot and flattening into the waist, which is the hollow a
     bell has and a cone does not */
  for (var bi = 1; bi <= 7; bi++) {
    var u = bi/7;
    BP.push([14 + 46*u, MM_.waistR + 44.5*Math.pow(1-u, 1.42)]);
  }
  BP.push([60, 33], [64, 33], [65.5, 30]);       // the flat ledge and its chamfer
  /* the baluster knop, turned by hand: 48 across at the spring, 65 at
     the bulge, drawn to the 35 collar */
  BP.push([66, 24], [69, 29], [72, 31.8], [76, 32.5],
          [80, 31.3], [84, 27.6], [87.5, 22], [90, 17.5]);
  BP.push([92, 16.5], [94, 11], [97, 10], [100, 8.5]);  // the small collar the stem enters
  lathe(BP, 0, 28);
  var VB = n;

  /* ==== 2. THE SWAN NECK, in `uMNeck` ==============================
     "a brass tube ~10 mm across that leaves the knop vertically, rises,
     and SWEEPS FORWARD in one curve (a swan neck)". One cubic: it leaves
     the base's axis straight up and arrives at the head's own origin
     leaning forward, which is where place.js puts the head - (0, 34,
     330) in this frame. The neck MEETS the head; it does not stop short
     of it, which is what the old straight stem did (a 34 mm gap with a
     brass peg hanging in it behind the hood - visible in the BEFORE
     crop, top left). ==== */
  var P0 = [0, MM_.baseH], P1 = [0, 206], P2 = [8, 318], P3 = [MM_.headY, MM_.headZ];
  var neck = [];
  for (var ni = 0; ni <= 15; ni++) {
    var t = ni/15, mt = 1-t;
    neck.push([mt*mt*mt*P0[0] + 3*mt*mt*t*P1[0] + 3*mt*t*t*P2[0] + t*t*t*P3[0],
               mt*mt*mt*P0[1] + 3*mt*mt*t*P1[1] + 3*mt*t*t*P2[1] + t*t*t*P3[1]]);
  }
  sweep(neck, 6.5, MM_.stemR, 1, 12);   // 13 across where it leaves the collar, 10 at the head
  var VN = n;

  /* ==== 3. THE PIVOT, in the head's frame ==========================
     "the shade hangs on a cross-bar between two small brass brackets at
     the stem's top; at each end of the shade a brass fitting (the
     photograph has a knurled nut and a small brass ring at one end).
     Small, but it is what says the shade TILTS."
     A shade holder: two arms from the neck's end out to the shade's two
     cheeks, a boss at each, and the knurled nut on one. Head-local z 0
     is 18 mm clear of the arch's crown, so the yoke stands over the
     hood and drops to it, as the photograph's does. ==== */
  function arm(x1, z1) {                      // a straight arm from the neck's end
    var S = 8, i, j, rows = [];
    var A = [0, 0, 0], B = [x1, 0, z1];
    var dx = B[0]-A[0], dz = B[2]-A[2], L = Math.hypot(dx, dz) || 1;
    var ux = dx/L, uz = dz/L;                 // along the arm, in the xz plane
    for (i = 0; i < 2; i++) {
      var P = i ? B : A; rows.push(n);
      for (j = 0; j < S; j++) {
        var t = j*2*Math.PI/S, c = Math.cos(t), s = Math.sin(t);
        /* the ring: the arm's own two normals - (0,1,0) and (-uz,0,ux) */
        var nx = c*(-uz), ny = s, nz = c*ux;
        pos.push(P[0] + 3.2*nx, P[1] + 3.2*ny, P[2] + 3.2*nz);
        nor.push(nx, ny, nz); prt.push(3); n++;
      }
    }
    for (j = 0; j < S; j++) {
      var j2 = (j+1)%S;
      idx.push(rows[0]+j, rows[1]+j, rows[0]+j2, rows[0]+j2, rows[1]+j, rows[1]+j2);
    }
  }
  arm(92, -30); arm(-92, -30);
  /* the two fittings on the cheeks, turned about x: a boss each side, a
     knurled nut on one (twelve flutes, alternate radii - knurling for the
     price of the ring it is made of) and a plain ring on the other */
  function fitting(xa, xb, r, flute) {
    var S = 12, i, j, rows = [];
    for (i = 0; i < 2; i++) {
      var X = i ? xb : xa; rows.push(n);
      for (j = 0; j < S; j++) {
        var t = j*2*Math.PI/S, c = Math.cos(t), s = Math.sin(t);
        var rr = flute && (j % 2) ? r*0.83 : r;
        pos.push(X, rr*c, rr*s); nor.push(0, c, s); prt.push(3); n++;
      }
    }
    for (j = 0; j < S; j++) {
      var j2 = (j+1)%S;
      idx.push(rows[0]+j, rows[1]+j, rows[0]+j2, rows[0]+j2, rows[1]+j, rows[1]+j2);
    }
    var k = n;                                 // the outer face, so the nut has an end
    pos.push(xb, 0, 0); nor.push(Math.sign(xb), 0, 0); prt.push(3); n++;
    for (j = 0; j < S; j++) {
      var t2 = j*2*Math.PI/S, rr2 = flute && (j % 2) ? r*0.83 : r;
      pos.push(xb, rr2*Math.cos(t2), rr2*Math.sin(t2));
      nor.push(Math.sign(xb), 0, 0); prt.push(3); n++;
    }
    for (j = 0; j < S; j++) idx.push(k, k+1+j, k+1+(j+1)%S);
  }
  /* both sit at the cheeks' own height, head-local z -30, on the axis the
     shade turns about */
  var PIV_Z = -30;
  function atPivot(xa, xb, r, flute) {
    var k0 = n; fitting(xa, xb, r, flute);
    for (var i = k0; i < n; i++) pos[i*3+2] += PIV_Z;
  }
  atPivot(90, 101, 9.0, 1);        // the knurled nut
  atPivot(-99, -90, 7.5, 0);       // the plain brass ring
  var VP = n;

  /* ==== 4. THE HOOD: A FLATTENED ARCH WITH CURVED CHEEKS ==========
     "a hood whose section is a flattened arch, the front lip a little
     flared, the ENDS curved cheeks (not flat discs)". The envelope is
     the 188 x 80 x 42 place.js publishes as MEASURED.deskLamp.shade -
     the three numbers scripts/test-room-measurements.js measures the
     whole fold sweep against - so this card changes the hood's SHAPE and
     not its size (OPEN 2 says what changing the size would cost).

     The section: y = 40*cos(pi t)*flare, h = 42*sin(pi t)^0.62. The 0.62
     is the flattening - at a quarter turn a true ellipse is at 0.707 of
     its rise and this arch is at 0.807, which is the photograph's
     shoulder. The front lip (t -> 0) flares 3.6 mm out and 2.5 mm down.
     The cheeks: the whole section is scaled by sqrt(1 - q^2) over the
     last 22 mm at each end, so the glass turns down and CLOSES the hood
     in a dome instead of being stopped by a flat disc.
     Normals are the surface's own, from its two parametric tangents. ==*/
  var HL = MM_.hoodHalfL, HD = MM_.hoodHalfD, HR = MM_.hoodRise;
  var LIPZ = MM_.hoodLipZ, X0 = HL - MM_.hoodCap, TS = 18;
  function flare(t) { var k = Math.max(0, 1 - t/0.12); return 1 + 0.09*k*k; }
  function drop(t) { var k = Math.max(0, 1 - t/0.10); return 2.5*k*k; }
  function dflare(t) { var h = 1e-4; return (flare(t+h) - flare(t-h))/(2*h); }
  function ddrop(t) { var h = 1e-4; return (drop(t+h) - drop(t-h))/(2*h); }
  function capS(x) {                      // the cheek's scale and its slope
    var ax = Math.abs(x);
    if (ax <= X0) return [1, 0];
    var q = Math.min(1, (ax - X0)/MM_.hoodCap), s = Math.sqrt(Math.max(0, 1 - q*q));
    var ds = s > 1e-4 ? -q/(MM_.hoodCap*s) : -1e4;
    return [s, ds*(x < 0 ? -1 : 1)];
  }
  var XS = [];                            // the stations along the hood
  [-X0, -X0*0.667, -X0*0.333, 0, X0*0.333, X0*0.667, X0].forEach(function (x) { XS.push(x); });
  for (var ci = 1; ci <= 4; ci++) {       // four courses per cheek, bunched at the tip
    var q2 = Math.sin(ci*Math.PI/8);
    XS.push(X0 + q2*MM_.hoodCap); XS.unshift(-X0 - q2*MM_.hoodCap);
  }
  var hoodRow = [];
  for (var si = 0; si < XS.length; si++) {
    var x = XS[si], cs = capS(x), s2 = cs[0], sp = cs[1];
    hoodRow.push(n);
    for (var ti = 0; ti <= TS; ti++) {
      var t2 = ti/TS, ph = Math.PI*t2;
      var ys = HD*Math.cos(ph)*flare(t2);
      var zs = HR*Math.pow(Math.max(0, Math.sin(ph)), 0.62);
      var y = ys*s2, z = LIPZ - drop(t2) + zs*s2;
      /* the two tangents, and the normal between them */
      var dys = HD*(-Math.PI*Math.sin(ph)*flare(t2) + Math.cos(ph)*dflare(t2));
      var sp2 = Math.max(1e-4, Math.sin(ph));
      var dzs = HR*0.62*Math.pow(sp2, 0.62-1)*Math.PI*Math.cos(ph);
      var c1 = dys*s2, d1 = -ddrop(t2) + dzs*s2;        // d/dt
      var a1 = ys*sp, b1 = zs*sp;                       // d/dx (x component 1)
      var nx2 = b1*c1 - a1*d1, ny2 = d1, nz2 = -c1;
      var Ln = Math.hypot(nx2, ny2, nz2) || 1;
      if (s2 <= 1e-4) { nx2 = (x < 0 ? -1 : 1); ny2 = 0; nz2 = 0; Ln = 1; }
      pos.push(x, y, z); nor.push(nx2/Ln, ny2/Ln, nz2/Ln); prt.push(2); n++;
    }
  }
  for (si = 0; si < XS.length - 1; si++) for (ti = 0; ti < TS; ti++) {
    var A2 = hoodRow[si]+ti, B2 = hoodRow[si]+ti+1;
    var C2 = hoodRow[si+1]+ti, D2 = hoodRow[si+1]+ti+1;
    idx.push(A2, C2, B2, B2, C2, D2);
  }
  var VH = n;

  /* ==== 5. THE BRASS WELT ==========================================
     "a thin brass rim along the whole lower edge and round the cheeks".
     The hood's lower edge is ONE closed oval now (the cheeks close it),
     so the welt is one band round that oval, 2 mm out and 4 mm down. It
     is also what gives a zero-thickness shell an edge to read. ==== */
  var loop = [];
  for (si = 0; si < XS.length; si++) {          // the front edge, west to east
    var x3 = XS[si], s3 = capS(x3)[0];
    loop.push([x3, HD*flare(0)*s3, LIPZ - drop(0)]);
  }
  for (si = XS.length - 2; si > 0; si--) {      // and the back edge home again
    var x4 = XS[si], s4 = capS(x4)[0];
    loop.push([x4, -HD*s4, LIPZ]);
  }
  var LN = loop.length, rimIn = [], rimOut = [];
  for (var li = 0; li < LN; li++) {
    var P = loop[li], Pp = loop[(li+LN-1)%LN], Pn = loop[(li+1)%LN];
    var tx = Pn[0]-Pp[0], ty3 = Pn[1]-Pp[1], Lt = Math.hypot(tx, ty3) || 1;
    tx /= Lt; ty3 /= Lt;
    var ox = ty3, oy = -tx;                      // the loop's outward, in plan
    if (ox*P[0] + oy*P[1] < 0) { ox = -ox; oy = -oy; }
    var dxo = MM_.rimW*ox, dyo = MM_.rimW*oy, dzo = -MM_.rimDrop;
    /* the band is ruled: its normal is across it, by its own tangent */
    var nx3 = ty3*dzo - 0, ny3 = 0 - tx*dzo, nz3 = tx*dyo - ty3*dxo;
    var Ln3 = Math.hypot(nx3, ny3, nz3) || 1;
    if (nx3*ox + ny3*oy < 0) { nx3 = -nx3; ny3 = -ny3; nz3 = -nz3; }
    rimIn.push(n);  pos.push(P[0], P[1], P[2]);
    nor.push(nx3/Ln3, ny3/Ln3, nz3/Ln3); prt.push(3); n++;
    rimOut.push(n); pos.push(P[0]+dxo, P[1]+dyo, P[2]+dzo);
    nor.push(nx3/Ln3, ny3/Ln3, nz3/Ln3); prt.push(3); n++;
  }
  for (li = 0; li < LN; li++) {
    var l2 = (li+1)%LN;
    idx.push(rimIn[li], rimOut[li], rimIn[l2], rimIn[l2], rimOut[li], rimOut[l2]);
  }
  var VR = n;

  /* ==== 6. THE PULL CHAIN, in `uMNeck` =============================
     "a bead chain ~150 mm long with a small brass ball hangs from under
     the shade's right-hand end ... it is the one thing on the lamp a
     hand has touched - build it."
     It hangs by GRAVITY, so it is in the untilted neck frame, not the
     head's. Its anchor is the head-local (94, 0, -52) of the shade's
     east cheek carried into that frame by the constant 38 degree tilt
     and the constant 34 mm offset: (94, 66.0, 289.0). EAST, not west:
     the west cheek's chain would hang 33 mm from the sheet's own NW
     corner and inside the fold's sweep, and a pull chain over the paper
     is a chain the map catches (measured, bl1-specs/clearance.py). ==== */
  var CX = 94, CY = 66.0, CZ = 289.0;
  var chain = [[CY, CZ], [CY, CZ - MM_.chainL]];
  var k0 = n; sweep(chain, MM_.chainR, MM_.chainR, 1, 6, false);
  for (var qi = k0; qi < n; qi++) pos[qi*3] += CX;
  /* the ball: a small lathe on its side, revolved about z and moved out */
  var BALL = [];
  for (var gi = 0; gi <= 6; gi++) {
    var g = gi/6*Math.PI;
    BALL.push([-Math.cos(g)*MM_.ballR, Math.max(0.001, Math.sin(g)*MM_.ballR)]);
  }
  var k1 = n; lathe(BALL, 1, 8);
  for (qi = k1; qi < n; qi++) {
    pos[qi*3] += CX; pos[qi*3+1] += CY; pos[qi*3+2] += CZ - MM_.chainL - MM_.ballR;
  }
  var VC = n;

  O.lamp.verts = { base: VB, neck: VN - VB, pivot: VP - VN, hood: VH - VP,
                   rim: VR - VH, chain: VC - VR, total: n, tris: idx.length/3 };
  return mesh(gl, pos, nor, prt, idx);
}
/* DL1 (item 14's tail): the lamp stands on the desk at every pose.
   Before, this block was gated on `?edgelamp=1` - off in every shipped
   frame - so the base painted nothing while its entry carried `cast 0 /
   contact 0`; the reviewer of U2: "no visible contact shadow under the lamp base ... appears to float slightly on the desk regardless of fold state"
   LT1's pool peaks at the base's own centre, which made it worse. CONTACT
   lh/(lh+d) off the base's own 18 mm, nought at 39.6 mm; CAST the books'
   own term at this entry's `sunAt` station, R27 (2)'s solid over it.
   `opts.own` as the head says. REPORT-room-DL1.md. */
var OAK_DECL =
  'uniform vec3 uLampB;    // R27: the lamp base, css px: x y r\n' +
  'uniform vec4 uLampSh;   // DL1: the light at the base\'s own station - dx dy len - and the base\'s height, css px\n' +
  'uniform vec2 uLampSk;   // DL1: the weights the shadow entry publishes - cast, contact\n';
var OAK_BODY = `
    vec2 lc = uLampB.xy;
    float lr = uLampB.z, lh = uLampSh.w;
    float dl = length(p - lc), dout = max(0.0, dl - lr);
    /* THE CAST: uLampSh.xyz IS uShSun at this entry's station, the box
       becoming the disc; after dark, the survey party's lantern. */
    float lblur = 10.0*(1.0 + (uSun2.x - 1.0)*0.5);
    col = mix(col, vec3(0.0), uLampSk.x*uSun2.y*cst
              *(1.0 - smoothstep(lr - lblur, lr + lblur,
                                 length(p - lc - uLampSh.xy*uLampSh.z*cst*8.0))));
    /* THE CONTACT: the rim's occlusion, which does not care what the hour
       is, and what says "standing"; closed at 2.2 base-heights so it is a
       line and not a bruise. */
    float lao = (lh/(lh + dout))*(1.0 - smoothstep(0.0, lh*2.2, dout));
    col = mix(col, vec3(0.0), uLampSk.y*lao);
`;

O.lamp = {
  VS: LAMP_VS, FS: LAMP_FS,
  mesh: function (gl, mk) { return lampMesh(gl, mk); },
  /* R76: the source as the light list wants it - entry ZERO of
     `RoomPlace.lights`, R75's slot; the reach is R76's corrected 1.6 m,
     0.52 being a reading pool, not a lamp in a room. */
  source: { col: [1.0, 0.72, 0.38], power: 1.60, headZ: 330 },
  mm: MM_
};

/* DL1: the entry's `cast`/`contact` are real and are what the oak block
   paints - R27 (2)'s 0.42 cast, both books' 0.34 contact - reaching it as
   `uLampSk` because `own` stays. */
var SHD = { box: [0, 0, 0, 0], height: 0, lift: 1, cast: 0.42, contact: 0.34 };
var NO_LAMP = Q.get('lamp') === '0';   /* place.js's own switch, read here too */
/* ==== BL1: TWO HEIGHTS, BECAUSE THE BASE NOW HAS TWO ==============
   DL1's `baseH` was 18 mm because the base WAS 18 mm - three stacked
   discs, every one of them at 68-82 mm radius. The bell is 100 mm tall,
   and 100 mm through DL1's `lh/(lh+d)*(1 - smoothstep(0, 2.2*lh, d))`
   would open a 220 mm bruise on the oak round a base that necks in to
   55 mm by 60 mm up - a lamp that darkens the wood a hand's width away.

   So: FOOT_H is what the CONTACT term is struck from, and it is the
   occluder at the rim, unchanged at 18 mm - the profile still carries
   r >= 66 of its 82 all the way to z = 18 (two stepped rings to 11, the
   bell's spring to 14, r 66.6 at 18), so the mass standing at the
   footprint is the same mass DL1 measured and the desk pose is 0 px.
   The entry's published `height` is the base's TRUE 100 mm, which the
   figures report and no shader reads (`uShK[i].w` is the list's spare
   word, and an `own` entry emits no arm at all - objects.js `shGLSL`).
   ================================================================ */
var FOOT_H = 18;
function baseH(lb) { return FOOT_H * lb.mm; }
O.piece('lamp', function () { /* the solid is place.js's: see the head */ }, {
  oak: { decl: OAK_DECL, body: OAK_BODY,
         uniforms: function (gl, p, ctx) {
           if (!p.u.uLampB) return;
           var lb = O.lampBase(ctx.S);
           gl.uniform3f(p.u.uLampB, lb.x, lb.y, lb.r);
           /* the BASE's own station, off the same `sunAt` the list strikes
              for every entry */
           var u = ctx.sunAt(lb.x, lb.y);
           gl.uniform4f(p.u.uLampSh, u[0], u[1], u[2], baseH(lb));
           /* DL1: `?lamp=0` takes the solid, the source and the pool, so it
              takes the shadow too. */
           gl.uniform2f(p.u.uLampSk, lampUp() ? SHD.cast : 0, lampUp() ? SHD.contact : 0);
         } },
  smoke: function () {
    return { edgeLamp: EDGE_LAMP, mm: LAMP_MM, r: LAMP_R_MM, off: NO_LAMP,
             cast: SHD.cast, contact: SHD.contact, h: SHD.height, foot: FOOT_H,
             verts: O.lamp.verts || null,
             roomMesh: !!(window.RoomPlace && RoomPlace.lampReady) };
  }
});
/* the head stands 330 mm up; the BASE is what is on the oak, its box
   the disc's own square. */
O.shadow('lamp', function (ctx) {
  var lb = O.lampBase(ctx.S), bx = SHD.box;
  /* DL1: nothing stands here under `?lamp=0`. */
  var r = lampUp() ? lb.r : 0;
  bx[0] = lb.x - r; bx[1] = lb.y - r; bx[2] = r * 2; bx[3] = r * 2;
  SHD.height = MM_.baseH * lb.mm;   /* BL1: the bell's own 100 mm */
  return SHD;
}, { own: 1 });

O.LAMP_MM = LAMP_MM;
O.LAMP_R_MM = LAMP_R_MM;
})();
